import Menu from './src/menu';

module.exports = Menu;


// WEBPACK FOOTER //
// ./src/components/menu/index.js